import { Memento } from './memento.js';
import { Themable } from 'monaco-editor/esm/vs/platform/theme/common/themeService.js';
class Component extends Themable {
    constructor(id, themeService, storageService) {
        super(themeService);
        this.id = id;
        this.id = id;
        this.memento = ( new Memento(this.id, storageService));
        this._register(storageService.onWillSaveState(() => {
            this.saveState();
            this.memento.saveMemento();
        }));
    }
    getId() {
        return this.id;
    }
    getMemento(scope, target) {
        return this.memento.getMemento(scope, target);
    }
    saveState() {
    }
}
export { Component };
